import { useTheme } from '@mui/material';
import { DoorBatteryWarningLevel } from 'graphql/generated/graphqlTypes';
import useBatteryStatusUI from 'hooks/useBatteryStatusUI/useBatteryStatusUI';
import useTranslation from 'hooks/useTranslation/useTranslation';
import React from 'react';
import styled from 'styled-components';
import Icon from 'ui/atoms/Icon/Icon';
import Typography from 'ui/atoms/Typography/Typography';
import ComponentWrapper from 'ui/templates/ComponentWrapper/ComponentWrapper';

export interface Props {
  status: DoorBatteryWarningLevel;
}

interface IconWrapperProps {
  opacity: null | string;
}

const IconWrapper = styled.div<IconWrapperProps>`
  align-items: center;
  justify-content: center;
  opacity: ${({ opacity }) => opacity};
  width: 1.5rem;
  height: 1.5rem;
`;

const TypographyWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const BatteryStatusItem: React.FC<React.PropsWithChildren<Props>> = ({ status }) => {
  const theme = useTheme();
  const { translation } = useTranslation();
  const { getBatteryData } = useBatteryStatusUI(translation);
  const batteryData = getBatteryData(status, theme);

  return (
    <ComponentWrapper alignItems="center" gap="0.5rem">
      <IconWrapper opacity={batteryData.iconOpacity}>
        <Icon name={batteryData.iconName} color={batteryData.iconColor} />
      </IconWrapper>
      <TypographyWrapper>
        <Typography variant="body4" color="lTextMedium">
          {batteryData.firstLineText}
        </Typography>
        <Typography variant="helper" color="error">
          {batteryData.secondLineText}
        </Typography>
      </TypographyWrapper>
    </ComponentWrapper>
  );
};

export default BatteryStatusItem;
